import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import GrassurnLogo from "./GrassurnLogo";

const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const ADMIN_PASSWORD = "grassurn2024admin";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setTimeout(() => {
      if (password === ADMIN_PASSWORD) {
        onLogin(true);
      } else {
        setError("Invalid password. Please try again.");
        setPassword("");
      }
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0D1F1E, #060D0D)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24
    }}>
      <div style={{
        width: "100%",
        maxWidth: 360,
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: 12,
        padding: "40px 32px"
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 32, display: "flex", justifyContent: "center" }}>
          <GrassurnLogo />
        </div>

        <h2 style={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 500,
          fontSize: 18,
          color: "#fff",
          textAlign: "center",
          marginBottom: 8
        }}>
          Admin Access
        </h2>
        <p style={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 300,
          fontSize: 13,
          color: "rgba(255,255,255,0.35)",
          textAlign: "center",
          marginBottom: 32
        }}>
          Enter your password to continue
        </p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              style={{
                width: "100%",
                padding: "11px 44px 11px 14px",
                boxSizing: "border-box",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.09)",
                borderRadius: 6,
                color: "#fff",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 300,
                fontSize: 13,
                outline: "none"
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "rgba(255,255,255,0.3)",
                display: "flex",
                alignItems: "center"
              }}
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {error && (
            <p style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 300,
              fontSize: 13,
              color: "#f87171",
              margin: 0
            }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: "100%",
              padding: "12px",
              background: isLoading ? "rgba(45,92,90,0.5)" : "#2D5C5A",
              border: "none",
              borderRadius: 6,
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 500,
              fontSize: 14,
              color: "#fff",
              cursor: isLoading ? "not-allowed" : "pointer",
              transition: "background 0.2s"
            }}
          >
            {isLoading ? "Verifying..." : "Sign In"}
          </button>
        </form>

        <p style={{
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 300,
          fontSize: 11,
          color: "rgba(255,255,255,0.15)",
          textAlign: "center",
          marginTop: 28
        }}>
          Grassurn Tech Inc. · Internal only
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
